import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 12, viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.498.94a.75.75 0 0 1 .063 1.058l-8 9a.75.75 0 0 1-1.122 0l-4-4.5a.75.75 0 1 1 1.122-.996L5 9.372l7.44-8.37a.75.75 0 0 1 1.058-.063", fill: "#fff" }));
const ForwardRef = forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
